import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useSound from "use-sound";

import { useRooms } from "../../contexts/RoomsProvider";
import { useGame } from "../../contexts/GameProvider";

import clickDownSfx from "../../sfx/bloop-1.mp3";
import clickOnSfx from "../../sfx/bloop-2.mp3";

import "./Home.css";

export default function Home() {
  const [nameField, setNameField] = useState("");

  const [clickDown] = useSound(clickDownSfx, { volume: 0.75 });
  const [clickOn] = useSound(clickOnSfx, { volume: 0.75 });
  const navigate = useNavigate();
  const { roomsDispatch, setRoomByAccessCode, rooms } = useRooms();
  const { gameDispatch, setName } = useGame();

  return (
    <div className="home">
      <div className="home-content">
        <h1 className="home-title">Red Flag</h1>
        <p>
          A video case-study challenge to see if you can spot the signs of fraud
        </p>
        <input
          type="text"
          value={nameField}
          onChange={(event) => {
            if (event.target.value.length < 30)
              setNameField(event.target.value);
          }}
          onKeyDown={(event) => {
            if (event.key !== "Enter") {
              return false;
            }

            roomsDispatch(setRoomByAccessCode("AAAA", rooms));

            gameDispatch(setName(nameField));

            navigate("/play");
          }}
          placeholder="Enter your name"
        />
        <button
          className="btn"
          disabled={!nameField.length}
          onMouseDown={clickDown}
          onMouseUp={() => {
            clickOn();

            roomsDispatch(setRoomByAccessCode("AAAA", rooms));

            gameDispatch(setName(nameField));

            navigate("/play");
          }}
        >
          Play
        </button>
      </div>
      <div className="home-footer">
        &copy; {new Date().getFullYear()} Interactive Workshops
      </div>
    </div>
  );
}
